// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleBindingApi } from './moduleBindingApi';
import type { TaskBindingApi } from './taskBindingApi';

/**
 * Slot binding information for API responses
 */
export interface SlotBinding {
  moduleBindings?: ModuleBindingApi[];
  taskBindings?: TaskBindingApi[];
}
